import getFuncBySite from '../../utils/getFuncBySite';

import { sites } from '../../helpers/globalVariables';
import bdc from './bdc';
import thd from './thd';

export default getFuncBySite({
  [sites.blinds]: bdc,
  [sites.theHomeDepot]: thd,
});
